import { RetrieveRequest } from '../services/RequestService';
import { api } from '../../config/Services';
import { Alert } from '../../components';

export function getOptionsDeactive(actionspage, options, code, name) {
    if (options.filter(({ value }) => value === code).length === 0 && actionspage !== 'create') {
        options.push({ label: name, value: code });
    }
    return options;
}

export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function jsUcfirst(string, separator = null) {
    if (separator !== null) {
        let result = [];
        let splitChar = string.split(separator);
        for (const field in splitChar) {
            result[field] = splitChar[field];
            // result[field] = splitChar[field].charAt(0).toUpperCase() + splitChar[field].slice(1).toLowerCase();
        }
        return result.join(" ");
    } else {
        return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    }
}

export function validationPassword(value) {
    if (!value.match(/[a-z]/g)) {
        return "At least 1 lowercase character.";
    } else if (!value.match(/[A-Z]/g)) {
        return "At least 1 uppercase character.";
    } else if (!value.match(/[0-9]/g)) {
        return "At least 1 digit number.";
    } else if (!value.match(/[^a-zA-Z\d]/g)) {
        return "At least 1 special character.";
    } else if (value.length < 8) {
        return "Minimum 8 characters.";
    } else if (!value.match(/^\S*$/)) {
        return "There is no blank space allowed.";
    } else if (value.length < 8) {
        return "Minimum 8 characters.";
    }
    return null;
}

export function getGeneralConfig(key, callback, forReport) {
    let paging = {
        limit: -1,
        page: 1
    }
    let sort = {
        key: 'asc'
    };
    let active = true;
    // key = "%" + key + "%";
    let criteria = { key, active };
    let url = api.url.masterdata.generalconfig.retrieve;
    let column = [];
    RetrieveRequest(url, criteria, sort, paging, column).then((response) => {
        const { status, result } = response;
        const { responsecode } = status || {};
        var value = null;
        var objRole = {};
        if (responsecode === '0000') {
            if (result.length > 0) {
                value = result[0].value;
                objRole = { 'key': key, 'value': value };
            }
        } else {
            Alert.error(status.responsemessage);
        }
        callback(forReport ? objRole : value);
    });
}

export function isArray(data, length) {
    let result = false;
    if (data) {
        if (typeof data === "object") {
            if (Array.isArray(data)) {
                if (typeof length === "number") {
                    if (data.length > length) {
                        result = true;
                    }
                } else {
                    result = true;
                }
            }
        }
    }
    return result;
}


export function debounce(fn, ms) {
    let timer;
    return _ => {
        clearTimeout(timer);
        timer = setTimeout(_ => {
            timer = null;
            fn.apply(this, arguments);
        }, ms);
    };
};
